onGplansRun.$inject = ["$transitions", "$state", "$location", "$rootScope", "$q", "AuthenticationNew", "GUARDS", "NavigationStack", "$anchorScroll", "$window", "ModalsService", "Intercom", "UserService"];export function onGplansRun(
$transitions,
$state,
$location,
$rootScope,
$q,
AuthenticationNew,
GUARDS,
NavigationStack,
$anchorScroll,
$window,
ModalsService,
Intercom,
UserService)
{
  "ngInject";

  /* Guard loading of user's console for unauthorized */
  $transitions.onBefore({
    to: 'gplans.userConsole.**' },
  function (transition) {

    return $q.resolve().
    then(function () {
      return GUARDS.isAuthorized().
      catch(function (err) {
        NavigationStack.push('auth', {
          url: transition.to().url // where to come back
        });
        $state.go('gplans.auth.login'); // <- must call NavigationStack.pop('auth') || .close() somehow
        throw 'unauthorized';
      });
    }).
    then(function () {
      return GUARDS.isCheckedin().
      then(function (res) {
        if (!res) throw res;
        return res;
      }).
      catch(function (err) {
        if (transition.to().name === 'gplans.userConsole.checkin') {
          // prevent infinite loop
          return true;
        }
        if (transition.to().name === 'gplans.userConsole.settings') {
          return true;
        }
        NavigationStack.push('checkin', {
          url: $location.url() // where to come back
        });
        $state.go('gplans.userConsole.checkin'); // <- must call NavigationStack.pop('checkin') || .close() somehow
        throw 'checkin needed';
      });
    });

  });

  $rootScope.$on('AUTH_EVENTS:notAuthenticated', function () {
    if (!$state.includes('gplans.userConsole')) return;
    AuthenticationNew.unauthenticate();
    NavigationStack.push({
      url: $state.current.url // back to current place
    });
    $state.go('gplans.auth.login'); // <- must call NavigationStack.pop() || .close() somehow
  });

  var isLog = false;

  $transitions.onCreate({}, function (transition) {
    isLog && console.warn('[transition onCreate ]', transition.from(), transition.to());
  });
  $transitions.onBefore({}, function (transition) {
    if ($window.gplansStorage.offerId) {
      $rootScope.offerId = $window.gplansStorage.offerId;
    }
    isLog && console.warn('[transition onBefore]', transition.from(), transition.to());
    ModalsService.closeAll('modal closed before navigation');


    if (transition.to().name.indexOf('gplans.userConsole.') == -1) {
      Intercom.afterIntercomMessengerBooted(function (el) {
        el.style.display = 'none';
      });
    } else {
      Intercom.afterIntercomMessengerBooted(function (el) {
        el.style.display = 'block';
      });
    }
  });
  $transitions.onStart({}, function (transition) {
    isLog && console.warn('[transition onStart]', transition.from(), transition.to());
  });
  $transitions.onEnter({}, function (transition) {
    isLog && console.warn('[transition onEnter ]', transition.from(), transition.to());
  });
  $transitions.onFinish({}, function (transition) {
    isLog && console.warn('[transition onFinish ]', transition.from(), transition.to());
    if (transition.to().name.indexOf('gplans.userConsole.') > -1 || UserService.data.id) {
      Intercom.bootOrUpdate(UserService.data);
    }
  });
  $transitions.onRetain({}, function (transition) {
    isLog && console.warn('[transition onRetain ]', transition.from(), transition.to());
  });
  $transitions.onExit({}, function (transition) {
    isLog && console.warn('[transition onExit ]', transition.from(), transition.to());
  });
  $transitions.onSuccess({}, function (transition) {
    isLog && console.warn('[transition onSuccess]', transition.from(), transition.to());
    $rootScope.isSidebarMobile = false; //close sidebar on mobile
    $anchorScroll();
    document.body.scrollTop = document.documentElement.scrollTop = 0;
    $rootScope.pageTitle = $state.current.title;
    angular.element('html title').html("".concat($rootScope.pageTitle || 'Loading', " | G-Plan"));
  });
  $transitions.onError({}, function (transition) {
    isLog && console.warn('[transition onError ]', transition.from(), transition.to());
  });


  // $transitions.onBefore({
  //   from: 'gplans.auth.**',
  //   to: 'gplans.userConsole.**'
  // }, function(transition) {
  //   angular.element('body').addClass('is-login-transition');
  // });
  //
  // $transitions.onSuccess({
  //   from: 'gplans.auth.**',
  //   to: 'gplans.userConsole.**'
  // }, function(transition) {
  //   $timeout(() => {
  //     angular.element('body').removeClass('is-login-transition');
  //   }, 2200);
  // });
  //
  // $transitions.onBefore({
  //   from: 'gplans.userConsole.**',
  //   to: 'gplans.auth.**'
  // }, function(transition) {
  //   angular.element('body').addClass('is-login-transition');
  // });
  //
  // $transitions.onSuccess({
  //   from: 'gplans.userConsole.**',
  //   to: 'gplans.auth.**'
  // }, function(transition) {
  //   $timeout(() => {
  //     angular.element('body').removeClass('is-login-transition');
  //   }, 2200);
  // });

}